export const SUPPORT_CASE_STATUS_LABELS = {
  open: 'Abierto',
  resolved: 'Resuelto',
  on_hold: 'En espera'
};

export const formatSupportCaseDate = (isoString, timeZone) => {
  if (!isoString) return '';
  return new Date(isoString).toLocaleString('es-MX', {
    timeZone,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};
